<template>
    <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
        <el-form :model="user" ref="user" label-width="0px" class="demo-dynamic form-horizontal detailPage">
            <div class="tab-content">
                <div>
                    <div class="panel-body">
                        <div class="ibox-content">
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Username
                                    <span style="color:red">*</span>
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="userName" :rules="[{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'blur'
                                    }]">
                                        <el-input v-model="user.userName" :name="'userName'" maxLength="50" />
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    {{ $t("message.password") }}
                                    <span v-if="!$route.query.id" style="color:red">*</span>
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="pwd" :rules="[{
                                        required: $route.query.id ? false : true,
                                        message: $t('message.required'),
                                        trigger: 'blur'
                                    }, {
                                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/,
                                        message: 'Please enter a password in the correct format'
                                    }]">
                                        <el-input type="password" v-model.trim="user.pwd" autocomplete="off" show-password
                                            :name="'pwd'" />
                                        <div class="passwordFormat">{{ $t("message.passwordFormat") }}</div>
                                    </el-form-item>

                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    {{ $t("message.email") }}
                                    <span style="color:red">*</span>
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="email" :rules="[{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'blur'
                                    },
                                    {
                                        type: 'email',
                                        message: 'Please input the correct email address',
                                        trigger: ['blur', 'change']
                                    }]">
                                        <el-input type="email" v-model.trim="user.email" :name="'email'" />
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Role
                                    <span style="color:red">*</span>
                                </label>
                                <div class="col-sm-5">
                                    <el-form-item prop="functionList" :rules="{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'change'
                                    }">
                                        <el-select clearable multiple v-model="user.functionList"
                                            name="role">
                                            <el-option :label="role.label" :value="role.value" :key="role.value"
                                                class="ng-binding" v-for="role in functionList"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Contact No
                                    <span style="color:red">*</span>
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="contactNo" :rules="[{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'blur'
                                    },{
                                        pattern: /^\d+$/,
                                        message: 'Please enter the number'
                                    }]">
                                        <el-input v-model="user.contactNo" :name="'contactNo'" maxLength="50" />
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Remark
                                    <span style="color:red">*</span>
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="remark" :rules="[{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'blur'
                                    }]">
                                        <el-input type="textarea" placeholder="" v-model="user.remark" maxlength="300"
                                            show-word-limit clearable :rows="5"></el-input>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    {{ $t("message.Status") }}
                                    <span style="color:red">*</span>
                                </label>
                                <div class="col-sm-5">
                                    <el-form-item prop="status" :rules="{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'change'
                                    }">
                                        <el-select clearable v-model="user.status" name="status">
                                            <el-option v-for="item in statusObj" :key="item.value" :label="item.label"
                                                :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="hr-line-dashed"></div>
                            <div class="form-group">
                                <div class="col-sm-12">
                                    <div class="pull-right">
                                        <el-button type="primary" v-if="(checkPermission('USER_LIST_EDIT') &&
                                            $route.query.id) ||
                                            (checkPermission('USER_LIST_ADD') &&
                                                !$route.query.id)
                                            " @click="checkEvent()">
                                            {{ $t("message.Save") }}
                                        </el-button>
                                        <el-button @click="showWarning()">
                                            {{ $t("message.Cancel") }}
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>
<script>
import config from "../config";
import sha256 from 'sha256'

export default {
    mixins: [config.globalMixin],
    data() {
        return {
            user: {
                id: null,
                pwd: "",
                userName: "",
                contactNo: '',
                functions: '',
                functionList: [],
                remark: '',
                email: "",
                status: "",
            },
        };
    },
    created() {
        this.init();
    },
    computed: {
        statusObj() {
            return [
                {
                    value: 1,
                    label: this.$i18n.t("message.Active")
                },
                {
                    value: 0,
                    label: this.$i18n.t("message.Inactive")
                }
            ]
        },
        functionList() {
            return [
                {
                    value: "1",
                    label: 'Redeem Gift'
                },
                {
                    value: "2",
                    label: 'Publicity'
                }
            ]
        },
        functionMap() {
            return {
                1: 'Redeem Gift',
                2: 'Publicity'
            }
        }
    },
    mounted() { },
    methods: {
        async init() {
            let id = this.$route.query.id;
            if (id) {
                let obj = this.getAuthObj();
                obj.id = id;
                obj.apiUrl = this.apiConfig.externalUserDetail;
                let data = await this.$store.dispatch("apiEvent", obj);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                data.data.result.functionList = data.data.result.functions.split(',')
                this.$set(this, "user", data.data.result);
            } else {
                let initUser = {
                    id: null,
                    pwd: "",
                    userName: "",
                    contactNo: '',
                    functions: '',
                    functionList: [],
                    remark: '',
                    email: "",
                    status: "",
                };
                this.$set(this, "user", initUser);
            }
        },
        showWarning(type) {
            var that = this;
            if (!type) {
                that.$router.go(-1);
            }
        },
        checkEvent() {
            this.$refs["user"].validate(valid => {
                if (valid) {
                    this.submit();
                } else {
                    return false;
                }
            });
        },
        async submit() {
            try {
                let obj = this.getAuthObj();
                obj.user = {}
                var data;
                this.user.functions = ''
                this.user.functionList.forEach((i, index) => {
                    this.user.functions += i
                    if (index < this.user.functionList.length - 1) this.user.functions += ','
                })
                if (this.$route.query.id) {
                    obj.id= this.user.id
                    obj.userName= this.user.userName
                    obj.email= this.user.email
                    obj.contactNo= this.user.contactNo
                    obj.remark= this.user.remark
                    obj.functions= this.user.functions
                    obj.status= this.user.status
                    if (this.user.pwd) {
                        obj.pwd = sha256(this.user.pwd);
                    }
                    obj.apiUrl = this.apiConfig.externalUserUpdate;
                    data = await this.$store.dispatch("apiEvent", obj);
                } else {
                    obj.id= this.user.id
                    obj.userName= this.user.userName
                    obj.email= this.user.email
                    obj.contactNo= this.user.contactNo
                    obj.remark= this.user.remark
                    obj.functions= this.user.functions
                    obj.status= this.user.status
                    if (this.user.pwd) {
                        obj.pwd = sha256(this.user.pwd);
                    }
                    obj.apiUrl = this.apiConfig.externalUserCreate;
                    data = await this.$store.dispatch("apiEvent", obj);
                }
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                if (data.data.status_code === "0") {
                    this.$router.go(-1);
                }
            } catch (err) {
            }
        },
    }
};
</script>
  